const Login = () => import('../../views/tmpLogin/Login.vue');
const Home = () => import('../../components/Home');

const Container = {
  template: `
    <div class="Container">
      <router-view></router-view>
    </div>
  `,
};

const router = {
  path: '/login/:sessionId',
  name: 'LoginContainer',
  component: Container,
  meta: {
    hideChildren: true,
  },
  children: [
    {
      path: '/login/:sessionId',
      name: 'LoginContainer',
      component: Login,
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页',
        light: '/',
      },
    },
    {
      path: '/home/:dateType',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页',
        light: '/',
      },
    },
  ],
};
export default router;



// WEBPACK FOOTER //
// ./src/router/modules/tmpLogin.js